// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-Button {
  display: inline-block;
  margin: 0;
  background-image: none;
  border: none;
  border-radius: 4px;
  font-family: 'IBM Plex Sans';
  font-weight: 600;
  font-style: normal;
  font-size: inherit;
  line-height: inherit;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.1s ease-in, outline 0.1s ease-in;
  outline: none;
  text-decoration: none;
  /* matches only when focusing via keyboard, but not on mouse click */
}
.n-Button:focus-visible {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
  z-index: 1;
}
.n-Button:hover {
  text-decoration: none;
}
.n-Button--square {
  display: flex;
  justify-content: center;
  align-items: center;
}
.n-Button--square.n-Button--size-sm {
  width: 16px;
}
.n-Button--square.n-Button--size-md {
  width: 24px;
}
.n-Button--square.n-Button--size-lg {
  width: 32px;
}
.n-Button--square.n-Button--size-xl {
  width: 48px;
}
.n-Button--square.n-Button--size-w-full {
  width: 100%;
}
.n-Button--size-sm {
  height: 16px;
  font-size: 12px;
  line-height: 16px;
}
.n-Button--size-md {
  height: 24px;
  font-size: 14px;
  line-height: 24px;
}
.n-Button--size-lg {
  height: 32px;
  font-size: 14px;
  line-height: 32px;
}
.n-Button--size-xl {
  height: 48px;
  font-size: 18px;
  line-height: 48px;
}
.n-Button--size-w-full {
  width: 100%;
  font-size: inherit;
  line-height: inherit;
}
.n-Button--variant-primary {
  color: var(--color-content-white);
  background-color: var(--color-accent-background-base);
}
.n-Button--variant-primary .v-icon {
  color: var(--color-content-white);
}
.n-Button--variant-primary:hover {
  color: var(--color-content-white);
  background-color: var(--color-accent-background-hover);
}
.n-Button--variant-primary:hover .v-icon {
  color: var(--color-content-white);
}
.n-Button--variant-primary:active {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-accent-background-hover) l c h / 0.97);
}
.n-Button--variant-primary:active .v-icon {
  color: var(--color-content-white);
}
.n-Button--variant-primary.n--pressed {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-accent-background-hover) l c h / 0.97);
}
.n-Button--variant-primary.n--pressed .v-icon {
  color: var(--color-content-white);
}
.n-Button--variant-primary.n--pressed:hover {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-accent-background-hover) l c h / 0.97);
}
.n-Button--variant-primary.n--pressed:hover .v-icon {
  color: var(--color-content-white);
}
.n-Button--variant-primary.n--disabled,
.n-Button--variant-primary.n--disabled:hover,
.n-Button--variant-primary.n--disabled:active,
.n-Button--variant-primary.n--disabled.n--pressed {
  color: oklch(from var(--color-content-white) l c h / 0.7);
  background-color: oklch(from var(--color-accent-background-base) l calc(c * 0.5) h / 0.8);
}
.n-Button--variant-primary.n--disabled .v-icon,
.n-Button--variant-primary.n--disabled:hover .v-icon,
.n-Button--variant-primary.n--disabled:active .v-icon,
.n-Button--variant-primary.n--disabled.n--pressed .v-icon {
  color: oklch(from var(--color-content-white) l c h / 0.7);
}
.n-Button--variant-basic {
  color: var(--color-content-base);
  background-color: var(--color-neutral-background-base);
  box-shadow: 0 0 0 1px var(--color-border-base);
}
.n-Button--variant-basic .v-icon {
  color: var(--color-icon-base);
}
.n-Button--variant-basic:hover {
  color: var(--color-content-base);
  background-color: var(--color-neutral-background-hover);
}
.n-Button--variant-basic:hover .v-icon {
  color: var(--color-icon-base);
}
.n-Button--variant-basic:active {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.n-Button--variant-basic:active .v-icon {
  color: var(--color-icon-base);
}
.n-Button--variant-basic.n--pressed {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.n-Button--variant-basic.n--pressed .v-icon {
  color: var(--color-icon-base);
}
.n-Button--variant-basic.n--pressed:hover {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.n-Button--variant-basic.n--pressed:hover .v-icon {
  color: var(--color-icon-base);
}
.n-Button--variant-basic.n--disabled,
.n-Button--variant-basic.n--disabled:hover,
.n-Button--variant-basic.n--disabled:active,
.n-Button--variant-basic.n--disabled.n--pressed {
  color: oklch(from var(--color-content-base) l c h / 0.5);
  background-color: var(--color-neutral-background-base);
}
.n-Button--variant-basic.n--disabled .v-icon,
.n-Button--variant-basic.n--disabled:hover .v-icon,
.n-Button--variant-basic.n--disabled:active .v-icon,
.n-Button--variant-basic.n--disabled.n--pressed .v-icon {
  color: oklch(from var(--color-icon-base) l c h / 0.5);
}
.n-Button--variant-tertiary {
  color: var(--color-content-base);
  background-color: var(--color-neutral-background-base);
}
.n-Button--variant-tertiary .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-tertiary:hover {
  color: var(--color-content-base);
  background-color: var(--color-neutral-background-hover);
}
.n-Button--variant-tertiary:hover .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-tertiary:active {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.n-Button--variant-tertiary:active .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-tertiary.n--pressed {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.n-Button--variant-tertiary.n--pressed .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-tertiary.n--pressed:hover {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.n-Button--variant-tertiary.n--pressed:hover .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-tertiary.n--disabled,
.n-Button--variant-tertiary.n--disabled:hover,
.n-Button--variant-tertiary.n--disabled:active,
.n-Button--variant-tertiary.n--disabled.n--pressed {
  color: oklch(from var(--color-content-base) l c h / 0.5);
  background-color: var(--color-neutral-background-base);
}
.n-Button--variant-tertiary.n--disabled .v-icon,
.n-Button--variant-tertiary.n--disabled:hover .v-icon,
.n-Button--variant-tertiary.n--disabled:active .v-icon,
.n-Button--variant-tertiary.n--disabled.n--pressed .v-icon {
  color: oklch(from var(--color-icon-subdued) l c h / 0.5);
}
.n-Button--variant-link {
  color: var(--color-accent-content-base);
  background-color: transparent;
}
.n-Button--variant-link .v-icon {
  color: var(--color-accent-content-base);
}
.n-Button--variant-link:hover {
  color: var(--color-accent-content-hover);
  background-color: transparent;
}
.n-Button--variant-link:hover .v-icon {
  color: var(--color-accent-content-base);
}
.n-Button--variant-link:active {
  color: var(--color-accent-content-down);
  background-color: transparent;
}
.n-Button--variant-link:active .v-icon {
  color: var(--color-accent-content-base);
}
.n-Button--variant-link.n--pressed {
  color: var(--color-accent-content-down);
  background-color: transparent;
}
.n-Button--variant-link.n--pressed .v-icon {
  color: var(--color-accent-content-base);
}
.n-Button--variant-link.n--pressed:hover {
  color: var(--color-accent-content-down);
  background-color: transparent;
}
.n-Button--variant-link.n--pressed:hover .v-icon {
  color: var(--color-accent-content-base);
}
.n-Button--variant-link.n--disabled,
.n-Button--variant-link.n--disabled:hover,
.n-Button--variant-link.n--disabled:active,
.n-Button--variant-link.n--disabled.n--pressed {
  color: oklch(from var(--color-accent-content-base) l calc(c * 0.5) h / 0.8);
  background-color: transparent;
}
.n-Button--variant-link.n--disabled .v-icon,
.n-Button--variant-link.n--disabled:hover .v-icon,
.n-Button--variant-link.n--disabled:active .v-icon,
.n-Button--variant-link.n--disabled.n--pressed .v-icon {
  color: oklch(from var(--color-accent-content-base) l calc(c * 0.5) h / 0.8);
}
.n-Button--variant-destructive {
  color: var(--color-content-white);
  background-color: var(--color-negative-background-base);
}
.n-Button--variant-destructive .v-icon {
  color: extract(var(--color-content-white), var(--color-negative-background-base), 3);
}
.n-Button--variant-destructive:hover {
  color: var(--color-content-white);
  background-color: var(--color-negative-background-hover);
}
.n-Button--variant-destructive:hover .v-icon {
  color: extract(var(--color-content-white), var(--color-negative-background-hover), 3);
}
.n-Button--variant-destructive:active {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-negative-background-hover) l c h / 0.97);
}
.n-Button--variant-destructive:active .v-icon {
  color: extract(var(--color-content-white), oklch(from var(--color-negative-background-hover) l c h / 0.97), 3);
}
.n-Button--variant-destructive.n--pressed {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-negative-background-hover) l c h / 0.97);
}
.n-Button--variant-destructive.n--pressed .v-icon {
  color: extract(var(--color-content-white), oklch(from var(--color-negative-background-hover) l c h / 0.97), 3);
}
.n-Button--variant-destructive.n--pressed:hover {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-negative-background-hover) l c h / 0.97);
}
.n-Button--variant-destructive.n--pressed:hover .v-icon {
  color: extract(var(--color-content-white), oklch(from var(--color-negative-background-hover) l c h / 0.97), 3);
}
.n-Button--variant-destructive.n--disabled,
.n-Button--variant-destructive.n--disabled:hover,
.n-Button--variant-destructive.n--disabled:active,
.n-Button--variant-destructive.n--disabled.n--pressed {
  color: oklch(from var(--color-content-white) l c h / 0.8);
  background-color: oklch(from var(--color-negative-background-base) l c h / 0.5);
}
.n-Button--variant-destructive.n--disabled .v-icon,
.n-Button--variant-destructive.n--disabled:hover .v-icon,
.n-Button--variant-destructive.n--disabled:active .v-icon,
.n-Button--variant-destructive.n--disabled.n--pressed .v-icon {
  color: oklch(from var(--color-content-white) l c h / 0.8);
}
.n-Button--variant-transparent {
  color: var(--color-content-base);
  background-color: transparent;
}
.n-Button--variant-transparent .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-transparent:hover {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-contrast) l c h / 0.06);
}
.n-Button--variant-transparent:hover .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-transparent:active {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-contrast) l c h / 0.11);
}
.n-Button--variant-transparent:active .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-transparent.n--pressed {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-contrast) l c h / 0.11);
}
.n-Button--variant-transparent.n--pressed .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-transparent.n--pressed:hover {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-contrast) l c h / 0.11);
}
.n-Button--variant-transparent.n--pressed:hover .v-icon {
  color: var(--color-icon-subdued);
}
.n-Button--variant-transparent.n--disabled,
.n-Button--variant-transparent.n--disabled:hover,
.n-Button--variant-transparent.n--disabled:active,
.n-Button--variant-transparent.n--disabled.n--pressed {
  color: oklch(from var(--color-content-base) l c h / 0.5);
  background-color: transparent;
}
.n-Button--variant-transparent.n--disabled .v-icon,
.n-Button--variant-transparent.n--disabled:hover .v-icon,
.n-Button--variant-transparent.n--disabled:active .v-icon,
.n-Button--variant-transparent.n--disabled.n--pressed .v-icon {
  color: oklch(from var(--color-icon-subdued) l c h / 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/button/Button.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/font.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/typo.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/button.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,qBAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;ECOA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EC8BA,oBAAA;EFtCA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yDAAA;EACA,aAAA;EACA,qBAAA;EAaA,oEAAoE;AACtE;AAXE;EGlBA,mBAAA;EACA,4CAAA;EHmBE,UAAA;AAcJ;AAXE;EACE,qBAAA;AAaJ;AAVE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAYJ;AATE;EACE,WAAA;AAWJ;AARE;EACE,WAAA;AAUJ;AAPE;EACE,WAAA;AASJ;AANE;EACE,WAAA;AAQJ;AALE;EACE,WAAA;AAOJ;AAHI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAKN;AAHI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAKN;AAHI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAKN;AAHI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAKN;AAHI;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;AAKN;AAAI;EIjFA,iCAAA;EACA,qDAAA;AJoFJ;AInFI;EACE,iCAAA;AJqFN;AI7EE;EAXE,iCAAA;EACA,sDAAA;AJ2FJ;AI1FI;EACE,iCAAA;AJ4FN;AIhFE;EAfE,iCAAA;EACA,+EAAA;AJkGJ;AIjGI;EACE,iCAAA;AJmGN;AInFE;EAnBE,iCAAA;EACA,+EAAA;AJyGJ;AIxGI;EACE,iCAAA;AJ0GN;AIvFI;EAtBA,iCAAA;EACA,+EAAA;AJgHJ;AI/GI;EACE,iCAAA;AJiHN;AIxFI;;;;EA5BA,yDAAA;EACA,yFAAA;AJ0HJ;AIzHI;;;;EACE,yDAAA;AJ8HN;AA7CI;EIpFA,gCAAA;EACA,sDAAA;EAiEF,8CAAA;AJoEF;AIpII;EACE,6BAAA;AJsIN;AI9HE;EAXE,gCAAA;EACA,uDAAA;AJ4IJ;AI3II;EACE,6BAAA;AJ6IN;AIjIE;EAfE,gCAAA;EACA,gFAAA;AJmJJ;AIlJI;EACE,6BAAA;AJoJN;AIpIE;EAnBE,gCAAA;EACA,gFAAA;AJ0JJ;AIzJI;EACE,6BAAA;AJ2JN;AIxII;EAtBA,gCAAA;EACA,gFAAA;AJiKJ;AIhKI;EACE,6BAAA;AJkKN;AIzII;;;;EA5BA,wDAAA;EACA,sDAAA;AJ2KJ;AI1KI;;;;EACE,qDAAA;AJ+KN;AA1FI;EIxFA,gCAAA;EACA,sDAAA;AJqLJ;AIpLI;EACE,gCAAA;AJsLN;AI9KE;EAXE,gCAAA;EACA,uDAAA;AJ4LJ;AI3LI;EACE,gCAAA;AJ6LN;AIjLE;EAfE,gCAAA;EACA,gFAAA;AJmMJ;AIlMI;EACE,gCAAA;AJoMN;AIpLE;EAnBE,gCAAA;EACA,gFAAA;AJ0MJ;AIzMI;EACE,gCAAA;AJ2MN;AIxLI;EAtBA,gCAAA;EACA,gFAAA;AJiNJ;AIhNI;EACE,gCAAA;AJkNN;AIzLI;;;;EA5BA,wDAAA;EACA,sDAAA;AJ2NJ;AI1NI;;;;EACE,wDAAA;AJ+NN;AA3HI;EIvGA,uCAAA;EACA,6BAAA;AJqOJ;AIpOI;EACE,uCAAA;AJsON;AI9NE;EAXE,wCAAA;EACA,6BAAA;AJ4OJ;AI3OI;EACE,uCAAA;AJ6ON;AIjOE;EAfE,uCAAA;EACA,6BAAA;AJmPJ;AIlPI;EACE,uCAAA;AJoPN;AIpOE;EAnBE,uCAAA;EACA,6BAAA;AJ0PJ;AIzPI;EACE,uCAAA;AJ2PN;AIxOI;EAtBA,uCAAA;EACA,6BAAA;AJiQJ;AIhQI;EACE,uCAAA;AJkQN;AIzOI;;;;EA5BA,2EAAA;EACA,6BAAA;AJ2QJ;AI1QI;;;;EACE,2EAAA;AJ+QN;AA5JI;EItHA,iCAAA;EACA,uDAAA;AJqRJ;AIpRI;EACE,oFAAA;AJsRN;AI9QE;EAXE,iCAAA;EACA,wDAAA;AJ4RJ;AI3RI;EACE,qFAAA;AJ6RN;AIjRE;EAfE,iCAAA;EACA,iFAAA;AJmSJ;AIlSI;EACE,8GAAA;AJoSN;AIpRE;EAnBE,iCAAA;EACA,iFAAA;AJ0SJ;AIzSI;EACE,8GAAA;AJ2SN;AIxRI;EAtBA,iCAAA;EACA,iFAAA;AJiTJ;AIhTI;EACE,8GAAA;AJkTN;AIzRI;;;;EA5BA,yDAAA;EACA,+EAAA;AJ2TJ;AI1TI;;;;EACE,yDAAA;AJ+TN;AA7LI;EIrIA,gCAAA;EACA,6BAAA;AJqUJ;AIpUI;EACE,gCAAA;AJsUN;AI9TE;EAXE,gCAAA;EACA,gEAAA;AJ4UJ;AI3UI;EACE,gCAAA;AJ6UN;AIjUE;EAfE,gCAAA;EACA,gEAAA;AJmVJ;AIlVI;EACE,gCAAA;AJoVN;AIpUE;EAnBE,gCAAA;EACA,gEAAA;AJ0VJ;AIzVI;EACE,gCAAA;AJ2VN;AIxUI;EAtBA,gCAAA;EACA,gEAAA;AJiWJ;AIhWI;EACE,gCAAA;AJkWN;AIzUI;;;;EA5BA,wDAAA;EACA,6BAAA;AJ2WJ;AI1WI;;;;EACE,wDAAA;AJ+WN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.n-Button {\n  display: inline-block;\n  margin: 0;\n  background-image: none;\n  border: none;\n  border-radius: @input-border-radius;\n  .IBMPlexSans-semibold();\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  cursor: pointer;\n  user-select: none;\n  transition: @background-transition, @outline-transition;\n  outline: none;\n  text-decoration: none;\n\n  /* matches only when focusing via keyboard, but not on mouse click */\n  &:focus-visible {\n    .n-outline();\n    z-index: 1;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &--square {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &--square&--size-sm {\n    width: @size--xs;\n  }\n\n  &--square&--size-md {\n    width: @size--sm;\n  }\n\n  &--square&--size-lg {\n    width: @size--md;\n  }\n\n  &--square&--size-xl {\n    width: @size--lg;\n  }\n\n  &--square&--size-w-full {\n    width: 100%;\n  }\n\n  &--size {\n    &-sm {\n      height: @size--xs;\n      font-size: @fontSize-xs;\n      line-height: @size--xs;\n    }\n    &-md {\n      height: @size--sm;\n      font-size: @fontSize-sm;\n      line-height: @size--sm;\n    }\n    &-lg {\n      height: @size--md;\n      font-size: @fontSize-sm;\n      line-height: @size--md;\n    }\n    &-xl {\n      height: @size--lg;\n      font-size: @fontSize-md;\n      line-height: @size--lg;\n    }\n    &-w-full {\n      width: 100%;\n      font-size: inherit;\n      line-height: inherit;\n    }\n  }\n\n  &--variant {\n    &-primary {\n      .button-variant-primary();\n    }\n    &-basic {\n      .button-variant-default();\n    }\n\n    &-tertiary {\n      @text: var(--color-content-base);\n      @icon: var(--color-icon-subdued);\n      @background: var(--color-neutral-background-base);\n      @background-hover: var(--color-neutral-background-hover);\n      @background-pressed: oklch(from var(--color-neutral-background-hover) l c h / 0.97);\n\n      .button-variant(@text, @background, @icon;                               // normal (fg, bg, icon)\n        @text, @background-hover, @icon;                                       // hover\n        @text, @background-pressed, @icon;                                     // pressed\n        @text, @background-pressed, @icon;                                     // pressed:hover\n        oklch(from @text l c h / 0.5), @background, oklch(from @icon l c h / 0.5)  // disabled\n      );\n    }\n\n    &-link {\n      @text: var(--color-accent-content-base);\n      @text-hover: var(--color-accent-content-hover);\n      @text-pressed: var(--color-accent-content-down);\n      @icon: var(--color-accent-content-base);\n      @background: transparent;\n\n      .button-variant(@text, @background, @icon;                                                             // normal (fg, bg, icon)\n        @text-hover, @background, @icon;                                                                     // hover\n        @text-pressed, @background, @icon;                                                                   // pressed\n        @text-pressed, @background, @icon;                                                                   // pressed:hover\n        oklch(from @text l calc(~\"c * 0.5\") h / 0.8), @background, oklch(from @icon l calc(~\"c * 0.5\") h / 0.8)  // disabled\n      );\n    }\n\n    &-destructive {\n      @text: var(--color-content-white);\n      @icon: var(--color-content-white);\n      @background: var(--color-negative-background-base);\n      @background-hover: var(--color-negative-background-hover);\n      @background-pressed: oklch(from var(--color-negative-background-hover) l c h / 0.97);\n\n      .button-variant(@text, @background;                                                           // normal (fg, bg)\n        @text, @background-hover;                                                                   // hover\n        @text, @background-pressed;                                                                 // pressed\n        @text, @background-pressed;                                                                 // pressed:hover\n        oklch(from @text l c h / 0.8), oklch(from @background l c h / 0.5), oklch(from @icon l c h / 0.8) // disabled\n      );\n    }\n\n    &-transparent {\n      @text: var(--color-content-base);\n      @icon: var(--color-icon-subdued);\n      @background: transparent;\n      @background-hover: oklch(from var(--color-contrast) l c h / 0.06);\n      @background-pressed: oklch(from var(--color-contrast) l c h / 0.11);\n\n      .button-variant(@text, @background, @icon;                              // normal (fg, bg)\n        @text, @background-hover, @icon;                                      // hover\n        @text, @background-pressed, @icon;                                    // pressed\n        @text, @background-pressed, @icon;                                    // pressed:hover\n        oklch(from @text l c h / 0.5), @background, oklch(from @icon l c h / 0.5) // disabled\n      );\n    }\n  }\n}\n","// font-variant (mixin)\n// Params:\n//   - @fontFamily : defaults to inherit\n//   - @fontWeight : defaults to inherit\n//   - @fontStyle : defaults to normal\n//   - @fontSize : defaults to inherit\n// Example:\n//   .my-font(@fontSize: inherit) {\n//       .font-variant(\"My Font\"; @font-weight-regular; normal; @fontSize);\n//   }\n//   .my-font-italic(@fontSize: inherit) {\n//       .font-variant(\"My Font\"; @font-weight-regular; italic; @fontSize);\n//   }\n.font-variant(@fontFamily: inherit; @fontWeight: inherit; @fontStyle: normal; @fontSize: inherit) {\n  font-family: @fontFamily;\n  font-weight: @fontWeight;\n  font-style: @fontStyle;\n  font-size: @fontSize;\n}\n","// Neptune Venus UI Typography\n////////////////////////////////////////////////////////////////////////////////\n@import '../variables';\n\n// Generic mixins\n.font-regular(@fontSize: inherit; @lineHeight: inherit) {\n  font-weight: @fontWeight-regular;\n  font-style: normal;\n  font-size: @fontSize;\n  line-height: @lineHeight;\n}\n\n.font-italic(@fontSize: inherit; @lineHeight: inherit) {\n  font-weight: @fontWeight-regular;\n  font-style: italic;\n  font-size: @fontSize;\n  line-height: @lineHeight;\n}\n\n.font-semibold(@fontSize: inherit; @lineHeight: inherit) {\n  font-weight: @fontWeight-semibold;\n  font-style: normal;\n  font-size: @fontSize;\n  line-height: @lineHeight;\n}\n\n.font-bold(@fontSize: inherit; @lineHeight: inherit) {\n  font-weight: @fontWeight-bold;\n  font-style: normal;\n  font-size: @fontSize;\n  line-height: @lineHeight;\n}\n\n//// IBM Plex Sans font variants\n// - Regular (*400*-500)\n.IBMPlexSans(@fontSize: inherit; @lineHeight: inherit) {\n  .font-variant(@IBMPlexSans; @fontWeight-regular; normal; @fontSize);\n  line-height: @lineHeight;\n}\n.IBMPlexSans-italic(@fontSize: inherit; @lineHeight: inherit) {\n  .font-variant(@IBMPlexSans; @fontWeight-regular; italic; @fontSize);\n  line-height: @lineHeight;\n}\n\n// - Semibold (600)\n.IBMPlexSans-semibold(@fontSize: inherit; @lineHeight: inherit) {\n  .font-variant(@IBMPlexSans; @fontWeight-semibold; normal; @fontSize);\n  line-height: @lineHeight;\n}\n\n// - Semibold Italic (600)\n.IBMPlexSans-semibold-italic(@fontSize: inherit; @lineHeight: inherit) {\n  .font-variant(@IBMPlexSans; @fontWeight-semibold; italic; @fontSize);\n  line-height: @lineHeight;\n}\n\n// - Bold (700)\n.IBMPlexSans-bold(@fontSize: inherit; @lineHeight: inherit) {\n  .font-variant(@IBMPlexSans; @fontWeight-bold; normal; @fontSize);\n  line-height: @lineHeight;\n}\n\n//// IBM Plex Sans Condensed font variants\n// - Regular (*400*-500)\n.IBMPlexSansCondensed(@fontSize: inherit; @lineHeight: inherit) {\n  .font-variant(@IBMPlexSansCondensed; @fontWeight-regular; normal; @fontSize);\n  line-height: @lineHeight;\n}\n\n//// JetBrains Mono font variants\n// - Regular (*400*-500)\n.JetBrainsMono(@fontSize: inherit) {\n  .font-variant(@JetBrainsMono; @fontWeight-regular; normal; @fontSize);\n}\n\n.text-ellipsis() {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.textEllipsis() {\n  .text-ellipsis();\n}\n\n.textEllipsisLeft() {\n  .text-ellipsis();\n  direction: rtl;\n  text-align: left;\n}\n\n.mark() {\n  border-radius: @layoutUnit-xxs;\n  color: var(--color-mark-content);\n  background: var(--color-mark-background);\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n",".button-variant(@normal; @normal-hover; @pressed; @pressed-hover; @disabled) {\n  .set-colors(@colors) {\n    color: extract(@colors, 1);\n    background-color: extract(@colors, 2);\n    & .v-icon {\n      color: extract(@colors, 3);;\n    }\n  }\n\n  & {\n    .set-colors(@normal);\n  }\n\n  &:hover {\n    .set-colors(@normal-hover);\n  }\n\n  &:active {\n    .set-colors(@pressed);\n  }\n\n  &.n--pressed {\n    .set-colors(@pressed);\n\n    &:hover {\n      .set-colors(@pressed-hover);\n    }\n  }\n\n  &.n--disabled {\n    &,\n    &:hover,\n    &:active,\n    &.n--pressed {\n      .set-colors(@disabled);\n    }\n  }\n}\n\n.button-variant-primary() {\n  @text: var(--color-content-white);\n  @icon: var(--color-content-white);\n  @background: var(--color-accent-background-base);\n  @background-hover: var(--color-accent-background-hover);\n  @background-pressed: oklch(from var(--color-accent-background-hover) l c h / 0.97);\n\n  .button-variant(@text, @background, @icon;                                                                   // normal (fg, bg, icon)\n    @text, @background-hover, @icon;                                                                           // normal:hover\n    @text, @background-pressed, @icon;                                                                         // pressed\n    @text, @background-pressed, @icon;                                                                         // pressed:hover\n    oklch(from @text l c h / 0.7), oklch(from @background l calc(~\"c * 0.5\") h / 0.8), oklch(from @icon l c h / 0.7) // disabled\n  );\n}\n\n.button-variant-default() {\n  @text: var(--color-content-base);\n  @icon: var(--color-icon-base);\n  @background: var(--color-neutral-background-base);\n  @background-hover: var(--color-neutral-background-hover);\n  @background-pressed: oklch(from var(--color-neutral-background-hover) l c h / 0.97);\n\n  .button-variant(@text, @background, @icon;                              // normal (fg, bg, icon)\n    @text, @background-hover, @icon;                                      // hover\n    @text, @background-pressed, @icon;                                    // pressed\n    @text, @background-pressed, @icon;                                    // pressed:hover\n    oklch(from @text l c h / 0.5), @background, oklch(from @icon l c h / 0.5) // disabled\n  );\n\n  box-shadow: 0 0 0 1px var(--color-border-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
